// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_52-7";
export var adjustableWidthBorderHeld = "_52-8";
export var arrow = "_52-3";
export var arrowButton = "_52-4";
export var headerCell = "_52-0";
export var help = "_52-2";
export var icon = "_52-1";
export var iconWrapper = "_52-6";
export var noBorder = "_52-b";
export var nonAdjustableWidthBorder = "_52-9";
export var nonAdjustableWidthBorderHeld = "_52-a";
export var textButton = "_52-5";